'use client';

import { ComponentProps } from 'react';
import { useCartItems } from '@/entities/cart';
import { cn } from '@/shared/lib/cn';
import { AnimatedNumber } from '@/shared/ui/animated-number';
import { Layout } from '@/shared/ui/layout';
import './cart-count.scss';

type Props = ComponentProps<typeof Layout>;

export const CartCount = ({ className, ...props }: Props) => {
    const items = useCartItems();
    const count = items.reduce((sum, item) => sum + item.quantity, 0);

    if (!count) {
        return null;
    }

    return (
        <Layout element="span" className={cn('cart-count', className)} {...props}>
            <AnimatedNumber value={count} />
        </Layout>
    );
};
